export const UPDATE_FORM_DATA = 'store/actions/UPDATE_FORM_DATA';
export const UPDATE_FORM_FILE_DATA = 'store/actions/UPDATE_FORM_FILE_DATA';
export const UPDATE_FORM_STATE = 'store/actions/UPDATE_FORM_STATE';
export const UPDATE_CANDIDATE_DETAILS = 'store/actions/UPDATE_CANDIDATE_DETAILS';
export const UPDATE_FACE_AUTH_DETAILS = 'store/actions/UPDATE_FACE_AUTH_DETAILS';
export const UPDATE_FILE_UPLOAD_STATUS = 'store/actions/UPDATE_FILE_UPLOAD_STATUS';
